import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';

import { ControlledSelect } from 'components/shared';

const optionsT = 'surchargesMaintenance.form.methodOptions';
export const methodOptions = [
  { value: '0', label: t(optionsT + '.method0') },
  { value: '1', label: t(optionsT + '.method1') },
  { value: '2', label: t(optionsT + '.method2') }
];

export default function MethodSelectSection() {
  const { control } = useFormContext();

  return (
    <ControlledSelect
      control={control}
      name="method"
      variant="outlined"
      label={t('surchargesMaintenance.form.method')}
      options={methodOptions}
    />
  );
}
